var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMaps = function SvgMaps(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6895 7.10938C17.8345 7.10938 17.9736 7.16699 18.0762 7.26955C18.1787 7.37211 18.2363 7.51121 18.2363 7.65625",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1426 7.65625C17.1426 7.51121 17.2002 7.37211 17.3028 7.26955C17.4053 7.16699 17.5444 7.10938 17.6895 7.10938",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6895 8.20313C17.5444 8.20313 17.4053 8.14551 17.3028 8.04295C17.2002 7.94039 17.1426 7.80129 17.1426 7.65625",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2363 7.65625C18.2363 7.80129 18.1787 7.94039 18.0762 8.04295C17.9736 8.14551 17.8345 8.20313 17.6895 8.20313",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6895 1.09375C18.5513 1.09375 19.4046 1.26349 20.2008 1.59329C20.997 1.92309 21.7205 2.40648 22.3298 3.01586C22.9392 3.62525 23.4226 4.34869 23.7524 5.14489C24.0822 5.94109 24.252 6.79445 24.252 7.65625C24.252 10.4577 20.332 15.7879 18.5513 18.0658C18.449 18.1968 18.3183 18.3027 18.1689 18.3755C18.0196 18.4483 17.8556 18.4862 17.6895 18.4862C17.5233 18.4862 17.3593 18.4483 17.21 18.3755C17.0607 18.3027 16.9299 18.1968 16.8276 18.0658C15.047 15.7894 11.127 10.4577 11.127 7.65625C11.127 5.91577 11.8184 4.24657 13.0491 3.01586C14.2798 1.78515 15.949 1.09375 17.6895 1.09375V1.09375Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94703 14.264C8.57879 14.3409 8.23662 14.5115 7.95357 14.7593C7.67052 15.0071 7.45616 15.3237 7.33119 15.6785L2.31307 30.991C2.19671 31.3209 2.16115 31.6738 2.20935 32.0202C2.25755 32.3667 2.38812 32.6965 2.5901 32.982C2.79208 33.2675 3.05958 33.5005 3.37017 33.6613C3.68077 33.8221 4.02539 33.9061 4.37515 33.9063H31.0043C31.3543 33.9062 31.6991 33.8222 32.0098 33.6613C32.3206 33.5004 32.5882 33.2673 32.7902 32.9816C32.9922 32.6959 33.1227 32.3658 33.1708 32.0192C33.2188 31.6726 33.183 31.3195 33.0664 30.9896L28.0483 15.6771C27.9224 15.3204 27.7061 15.0024 27.4206 14.7542C27.1351 14.506 26.7901 14.3361 26.4193 14.261",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.127 33.9048L13.3145 20.7812",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.252 33.9048L22.0645 20.7812",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5498 27.3438H31.8721",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6582 20.7812H13.3145",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0645 20.7812H29.7207",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaps, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Maps.34b5dbcc.svg";
export { ForwardRef as ReactComponent };